import { AppComponent } from './app/app.component';
import { CookieModule } from 'ngx-cookie';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { de } from 'date-fns/locale';
import { DateFnsConfigurationService } from 'ngx-date-fns';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { FrameState } from '@mng/mng-frame';
import { ConfigState, MngConfigModule } from '@mng/mng-config';
import { NgxsModule } from '@ngxs/store';
import { errorHandlingInterceptor, MgsActiveState, routes } from '@mng/mgs-ui';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { providersForDate } from '@mng/mng-inputs';

const dateFnsDeutschConfig = new DateFnsConfigurationService();
dateFnsDeutschConfig.setLocale(de);

const globalRippleConfig: RippleGlobalOptions = {
  terminateOnPointerUp: false,
  disabled: false,
  animation: { enterDuration: 250, exitDuration: 80 }
};
registerLocaleData(localeDe, 'de', localeDeExtra);

bootstrapApplication(AppComponent, {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(CookieModule.withOptions(), MngConfigModule, NgxsModule.forRoot([ConfigState, FrameState])),
    provideRouter(routes, withViewTransitions(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: DateFnsConfigurationService, useValue: dateFnsDeutschConfig },
    { provide: LOCALE_ID, useValue: 'de-AT' },
    [...providersForDate],
    provideHttpClient(withXhr(), withInterceptors([errorHandlingInterceptor])),
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'mgs', separator: '_', caseSensitive: true }),
      withLocalStorage(),
      withSessionStorage()
    ),
    MgsActiveState
  ]
}).catch((err) => console.error(err));
